import api from '../lib/axios';
export async function getReportCategories() {
    const { data } = await api.get('/api/admin/report-categories');
    return data.data;
}
export async function createReportCategory(body) {
    const { data } = await api.post('/api/admin/report-categories', body);
    return data.data;
}
export async function updateReportCategory(id, body) {
    const { data } = await api.patch(`/api/admin/report-categories/${id}`, body);
    return data.data;
}
/** `moveTo` is required when the category still has reports or agents. */
export async function deleteReportCategory(id, moveTo) {
    const { data } = await api.delete(`/api/admin/report-categories/${id}`, {
        params: moveTo ? { move_to: moveTo } : undefined,
    });
    return data;
}
